export const APIStatus = {
  IDLE: 'idle',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  FAILED: 'failed',
  ERROR: 'error',
  REJECTED: 'rejected',
};

export type APIStatus = (typeof APIStatus)[keyof typeof APIStatus];
